import * as Sentry from '@sentry/react';

// Handlers de socket rodavam sem try/catch: um payload fora do formato esperado
// (ex.: `data.data.clientes_id` quando `data.data` nao veio) estourava dentro do
// io.on e o alerta simplesmente nao acontecia, sem nenhum rastro. Envolver todos
// os handlers garante que uma falha em um evento nao derrube o resto.
const reportar = (evento, err, payload) => {
  console.error(`[socket] handler "${evento}" falhou`, err, payload);
  try {
    Sentry.captureException(err, { tags: { socketEvent: evento } });
  } catch {
    // Sentry indisponivel nao pode virar um segundo erro.
  }
};

export const safeHandler = (evento, fn) => (...args) => {
  try {
    const retorno = fn(...args);
    // Handlers async rejeitam fora do try/catch sincrono.
    if (retorno && typeof retorno.catch === 'function') {
      retorno.catch((err) => reportar(evento, err, args[0]));
    }
    return retorno;
  } catch (err) {
    reportar(evento, err, args[0]);
    return undefined;
  }
};

export default safeHandler;
